import {
  TextNode,
  SerializedTextNode,
  NodeKey,
  EditorConfig,
  LexicalNode
} from "lexical";

export type SerializedMergeFieldNode = {
  type: "merge-field";
  version: 1;
  name: string;
} & SerializedTextNode;

export class MergeFieldNode extends TextNode {
  __name: string;

  constructor(name: string, text?: string, key?: NodeKey) {
    super(text ?? `%%${name}%%`, key);
    this.__name = name;
  }

  static getType(): string {
    return "merge-field";
  }

  static clone(node: MergeFieldNode): MergeFieldNode {
    return new MergeFieldNode(node.__name, node.__text, node.__key);
  }

  createDOM(config: EditorConfig): HTMLElement {
    const dom = super.createDOM(config);
    dom.classList.add("merge-field-token"); // styling hook
    return dom;
  }

  exportJSON(): SerializedMergeFieldNode {
    return {
      ...super.exportJSON(),
      type: "merge-field",
      version: 1,
      name: this.__name,
    };
  }

  static importJSON(serialized: SerializedMergeFieldNode): MergeFieldNode {
    return new MergeFieldNode(serialized.name, serialized.text);
  }
}

export function $createMergeFieldNode(name: string): MergeFieldNode {
  return new MergeFieldNode(name);
}

export function $isMergeFieldNode(node: LexicalNode | null): node is MergeFieldNode {
  return node instanceof MergeFieldNode;
}
